<template>
  <CModal
    @mtdclosemodal="mtdclosemodal"
    :show="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'xl'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <div class="row mx-0 px-2">
      <div class="row mx-0 px-0">
        <div class="col-md-3 p-2 mt-200">
          <div class="input-group input-group-lg">
            <input
              class="form-control form-control-lg inpunt-rounded"
              type="text"
              @keypress="isNumber($event)"
              v-model="client.document"
              @keypress.enter="mtdSearchDocument"
              maxlength="12"
              placeholder="Documento"
              aria-label=".form-control-lg example"
            />
            <div class="input-group-append">
              <button
                class="btn btn-search-doc"
                type="button"
                @click="mtdSearchDocument"
                title="Buscar documento"
              >
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6 p-2">
          <input
            class="form-control form-control-lg inpunt-rounded"
            type="text"
            v-model="client.fullName"
            :disabled="disabledPatient"
            placeholder="Nombres y apellidos del paciente"
            aria-label=".form-control-lg example"
          />
        </div>
        <div class="col-md-3 p-2">
          <input
            class="form-control form-control-lg inpunt-rounded"
            type="text"
            v-on:keypress="isNumber($event)"
            @keyup="mtdVerifEdad"
            v-model="client.yearOld"
            maxlength="3"
            placeholder="Edad"
            aria-label=".form-control-lg example"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <button @click="mtdclosemodal" class="btn btn-danger btn-sm">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      <button class="btn btn-success btn-sm" @click="mtdaction()">
        <i class="fas fa-save"></i>
        Guardar
      </button>
      &nbsp;
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import { mapActions } from "vuex";

export default {
  name: "c-modal-beads",

  data() {
    return {
      swal: null,
      client: {
        document: "",
        fullName: "",
        yearOld: "",
      },
      disabledPatient: true,
    };
  },
  components: {
    CModal,
    SweetAlert,
  },

  props: {
    title: String,
    boo_modal: Boolean,
    bed_id: [String, Number],
  },
  watch: {},
  methods: {
    ...mapActions(["get", "post"]),
    mtdclosemodal() {
      this.client = {
        document: "",
        fullName: "",
        yearOld: "",
      };
      this.$emit("mtdclosemodalRegPatient");
    },
    mtdSearchDocument: function () {
      let length = this.client.document.length;
      if (length < 8) {
        this.$refs.SweetAlert.showWarning(
          "Debe ingresar 8 dígitos cómo mínimo"
        );
        return;
      }
      switch (length) {
        case 8:
          this.mtdSendRequestForDni(); //Enviar petición para DNI - 8 Dígitos
          break;
        case 9:
          this.mtdSendRequestForCE(); //Enviar para CE - 9 Dígitos
          break;
        default:
          this.disabledPatient = false;
          this.client.celphone = "";
          this.client.email = "";
          this.client.fullName = "";
          this.client.yearOld = "";
          break;
      }
    },
    mtdSendRequestForDni() {
      this.get({
        url: `${this.$store.getters.get__url}/reniec/${this.client.document}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.boo == 3) {
            this.$refs.SweetAlert.showWarning("DNI no encontrado");
            this.disabledPatient = false;
            this.client.fullName = "";
          } else {
            this.client.fullName = `${response.data.name} ${response.data.last_name}`;
            if (response.data.hasOwnProperty("patient")) {
              this.client.yearOld = response.data.patient.year;
            } else {
              this.client.yearOld = "";
              this.disabledPatient = true;
            }
          }
        })
        .catch((errors) => {
          console.log(errors);
          this.disabledPatient = false;
          this.client.fullName = "";
        });
    },
    mtdSendRequestForCE() {
      this.get({
        url: `${this.$store.getters.get__url}/cee/${this.client.document}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode !== 200) {
            this.$refs.SweetAlert.showWarning(
              "Número de documento no encontrado"
            );
            this.disabledPatient = false;
            this.client.fullName = "";
            this.client.yearOld = "";
            return;
          }
          let patient = response.data.patient;
          this.client.fullName = patient.name;
          this.client.yearOld = patient.year ?? "";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mtdVerifEdad: function () {
      if (!this.client.yearOld || this.client.yearOld.length <= 0) {
        return;
      }
      if (this.client.yearOld > 110) {
        this.client.yearOld = "";
        this.$refs.SweetAlert.showWarning("Edad incorrecta");
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdaction: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/Emergency/regpatient",
        token: this.$store.getters.get__token,
        params:{
            bed_id: this.bed_id,
            patient: this.client,
            user: this.$store.getters.get__user.id
        }
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (response.data && response.data.alreadyAdmitted) {
              this.$refs.SweetAlert.showWarning(response.message);
              return;
            }
            this.mtdclosemodal();
            this.$emit("mtdCommitRegPatient");
          }
        })
        .catch((errors) => {
          console.log(errors);
          this.$refs.SweetAlert.showWarning(
            errors?.response?.data?.message ?? "Ocurrió un error al registrar al paciente"
          );
        });
    },
  },
};
</script>
<style scoped>
.bg-clinica {
  background-color: #900052 !important;
  color: white;
}
.bg-clinica:hover {
  color: white;
}
.bg-light {
  color: black !important;
}

/* ============================================================
   Botón de búsqueda de documento — diseño formal B/N
   ============================================================ */
.btn-search-doc {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* Espacio a la izquierda entre input y botón */
  margin-left: 8px;

  /* Tamaño consistente con el input (input-group-lg) */
  height: calc(1.5em + 1rem + 2px);
  padding: 0 1.25rem;

  /* Estilo formal B/N */
  background-color: #ffffff;
  color: #000000;
  border: 1.5px solid #000000;

  /* Redondeado consistente con inpunt-rounded */
  border-radius: 50rem;

  /* Tipografía e ícono */
  font-size: 1rem;
  font-weight: 600;

  /* Animación suave para el hover */
  transition: background-color 0.2s ease, color 0.2s ease,
    border-color 0.2s ease, transform 0.1s ease;

  /* Sin sombra por defecto (formal) */
  box-shadow: none;
}

/* Hover: inversión B/N */
.btn-search-doc:hover {
  background-color: #cecece;
  color: #030303;
  border-color: #000000;
}

/* Hover del ícono */
.btn-search-doc:hover i {
  color: #ffffff;
}

/* Active (click): feedback sutil sin romper la formalidad */
.btn-search-doc:active,
.btn-search-doc:focus {
  background-color: #000000;
  color: #ffffff;
  border-color: #000000;
  outline: none;
  box-shadow: none;
  transform: scale(0.98);
}

/* Foco accesible para teclado */
.btn-search-doc:focus-visible {
  outline: 2px solid #000000;
  outline-offset: 2px;
}

/* Ícono */
.btn-search-doc i {
  color: #000000;
  transition: color 0.2s ease;
  font-size: 1rem;
}
</style>